
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.995 35.148l-5.766 6.368c-2.634 2.912-7.15-1.045-4.448-4.028L50.58 35.5H35v15.078l1.988-1.799c2.936-2.663 6.972 1.783 4.028 4.449l-6.365 5.763a3.99 3.99 0 01-5.3.003l-6.367-5.766c-2.948-2.67 1.094-7.11 4.028-4.448L29 50.579V35.501H13.42l1.8 1.987c2.71 2.994-1.842 6.91-4.45 4.028l-5.762-6.365a3.992 3.992 0 01-.003-5.299l5.766-6.368c2.66-2.94 7.113 1.085 4.448 4.029l-1.799 1.986H29V13.421l-1.988 1.799c-2.935 2.662-6.973-1.783-4.028-4.449l6.365-5.763a3.99 3.99 0 015.3-.003l6.367 5.766c2.997 2.714-1.153 7.055-4.028 4.448L35 13.421v16.078H50.58l-1.8-1.986c-2.66-2.94 1.786-6.975 4.45-4.029l5.762 6.365a3.992 3.992 0 01.003 5.3z"}})])
          )
        }
      }
    